import React from 'react'
import Stack from '@mui/material/Stack'
import Clients from './clients'
export default () => {
  return (
    <Stack
      direction="row"
      justifyContent="space-evenly"
      alignItems="flex-start"
      spacing={2}
    >
      <Clients/>
    </Stack>
  )
}